// Colours generated from https://oklch.com.

export const PLACEHOLDER_BLUE = 'hsla(201, 98%, 41%, 0.08)';
export const PLACEHOLDER_GREEN = `rgba(71, 149, 62, 0.08)`;
export const PLACEHOLDER_PINK = 'rgba(197, 85, 117, 0.08)';
export const PLACEHOLDER_VIOLET = 'rgba(149, 103, 197, 0.08)';

export const PLACEHOLDER_BLUE_BORDER = 'rgba(54,135,204)';
